export interface ImageEffects {
  blurCss: string | null;
  grayscaleCss: string | null;
  invertCss: string | null;
}

export function buildImageEffects({
  blurAmount,
  isBlurry,
  isNoColor,
  isInverted,
}: {
  blurAmount: number;
  isBlurry: boolean;
  isNoColor: boolean;
  isInverted: boolean;
}): ImageEffects {
  const effects: ImageEffects = {
    blurCss: null,
    grayscaleCss: null,
    invertCss: null,
  };

  if (isBlurry) {
    const amount = Number.isFinite(blurAmount) ? blurAmount : 10;
    effects.blurCss = `blur(${amount}px)`;
  }

  if (isNoColor) {
    effects.grayscaleCss = 'grayscale(100%)';
  }

  if (isInverted) {
    effects.invertCss = 'invert(100%)';
  }

  return effects;
}

export function combineFilters(effects: ImageEffects): string {
  const filters = [effects.grayscaleCss, effects.blurCss, effects.invertCss].filter(Boolean);
  return filters.join(' ');
}

